import React, { Component, useState } from 'react';
import { connect, } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { autoLoginQRSession, login, register } from 'actions/auth';
import { withRouter } from '../withRouter';
import styles from '../Forms/FormStyles.module.scss'
import { Link, createSearchParams, redirect } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import QRLogin from "components/Roku/QRLogin/QRLogin"
import AuthService from "services/auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useGoogleLogin } from '@react-oauth/google';
import { faGoogle, faApple } from '@fortawesome/free-brands-svg-icons';
import DotLoader from 'components/Utlility/DotLoader';
import { APP_TYPES } from "constants/AppTypes";

class Login extends Component {
    static displayName = Login.name;

    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            loading: false,
            rememberMe: false,
            showMainNav: false,
            errorMessage: "",
            width: window.innerWidth,
            view: "loginOrSignUp",
            showAppleWarning: false,
        };
    }

    updateWindowSize = () => {
        this.setState({ width: window.innerWidth });
    };

    async componentDidMount() {
        window.addEventListener('resize', this.updateWindowSize);
        const appleRedirectURI = window.location.origin + "/login";
        console.log("appleRedirectURI: ", appleRedirectURI);

        if (window.AppleID) {
            window.AppleID.auth.init({
                clientId: process.env.REACT_APP_APPLE_CLIENT_ID || "com.gamecity.web",
                scope: "name email",
                redirectURI: appleRedirectURI,
                usePopup: true,
            });
        }

        window.handleNativeGoogleAuth = (token) => {
            this.onGoogleLogin({ access_token: token });
        };

        const searchParams = new URLSearchParams(window.location.search);
        const QRSessionID = searchParams.get("QRSessionID");
        const authCode = searchParams.get("code");
        const provider = searchParams.get("provider");

        // Handle Apple Sign-In redirect callback
        if (authCode && provider === "apple") {
            console.log("🍎 Received Apple authorization code from redirect");
            console.log("🍎 QRSessionID from URL:", QRSessionID);
            this.setState({ QRSessionID: QRSessionID, loading: true });
            this.onAppleLogin(authCode);

            const cleanUrl = window.location.origin + window.location.pathname;
            if (QRSessionID) window.history.replaceState({}, document.title, cleanUrl + `?QRSessionID=${QRSessionID}`);
            else window.history.replaceState({}, document.title, cleanUrl);
            return;
        }

        // Handle Google Sign-In redirect callback
        if (authCode && provider === "google") {
            console.log("🔵 Received Google authorization code from redirect");
            console.log("🔵 QRSessionID from URL:", QRSessionID);
            this.setState({ QRSessionID: QRSessionID, loading: true });
            this.onGoogleLogin({ code: authCode });

            const cleanUrl = window.location.origin + window.location.pathname;
            if (QRSessionID) window.history.replaceState({}, document.title, cleanUrl + `?QRSessionID=${QRSessionID}`);
            else window.history.replaceState({}, document.title, cleanUrl);
            return;
        }

        this.setState({ QRSessionID: QRSessionID });
        if (this.props.auth.isLoggedIn) {
            if (QRSessionID) {
                const UserID = this.props.auth.user.id;
                this.setState({ loading: true });
                await this.props.autoLoginQRSession(QRSessionID, UserID);
                this.setState({ loading: false });
                return setTimeout(() => this.props.navigate(`/join?QRSessionID=${QRSessionID}`));
            }
            return setTimeout(() => this.props.navigate("/"));
        } else {
            const rememberMe = localStorage.getItem("rememberMe");
            const email = localStorage.getItem("email");

            if (rememberMe === true) {
                this.setState({ rememberMe, email });
            }
        }
    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowSize);
    }

    onChangeEmail = (e) => {
        const email = e.target.value;

        this.setState({ email });
    };

    onChangePassword = (e) => {
        const password = e.target.value;
        const validLength = password.length >= 8;
        const hasNumber = (/\d/g).test(password);
        const upperCase = (/[A-Z]/g).test(password);
        const lowerCase = (/[a-z]/g).test(password);
        this.setState({ password, validLength, hasNumber, upperCase, lowerCase });
    };

    checkAccountExists = (e) => {
        e.preventDefault();
        if (this.state.loading) return;
        this.setState({ loading: true, errorMessage: "" });
        const email = this.state.email;
        AuthService.checkAccountExists(email)
            .then((res) => {
                if (res.message === true) this.setState({ view: "login" })
                else if (res.message === false) this.setState({ view: "register" })
                else this.setState({ errorMessage: "Something whent wrong" });
            }).catch((err) => {
                this.setState({ errorMessage: err });
            }).finally(() => {
                this.setState({ loading: false });
            })
    }

    handleLoginViaEmail = (e) => {
        e.preventDefault();

        if (!this.state.loading) {
            this.setState({ loading: true, errorMessage: "" });

            const email = this.state.email;
            const password = this.state.password;

            if (this.state.rememberMe) {
                localStorage.setItem('rememberMe', this.state.rememberMe);
                localStorage.setItem('email', email);
            }

            const req = {
                provider: "none",
                email: email,
                password: password,
                QRSessionID: this.state.QRSessionID,
                country: this.props.pricing.countryCode
            };
            this.props.login(req)
                .then((res) => {
                    console.log(res);
                    this.onLogin(this.state.QRSessionID);
                })
                .catch((err) => {
                    this.setState({ loading: false, errorMessage: err });
                });
        }
    };

    onQRLogin = (QRSessionID) => {
        this.props.navigate(`/lobby/?QRSessionID=${QRSessionID}`);
    }

    onLogin = (QRSessionID = null) => {
        if (this.props.modal) {
            this.props.closeModal(true);
        } else {
            const returnURL = new URLSearchParams(window.location.search).get("returnURL");
            console.log("return url : ", returnURL);
            if (returnURL) {
                this.props.navigate(decodeURIComponent(returnURL));
            } else {
                if (QRSessionID) this.props.navigate(`/join/?QRSessionID=${QRSessionID}`);
                else this.props.navigate("/");
            }
        }
    }

    handleRegisterViaEmail = (e) => {
        e.preventDefault();

        if (!this.state.loading) {
            this.setState({ loading: true, errorMessage: "", });
            if (this.validate()) {
                const email = this.state.email;
                const password = this.state.password;
                this.props.register(email, password, this.props.pricing.countryCode)
                    .then((res) => {
                        console.log(res);
                        this.props.login({ provider: "none", email: email, password: password, QRSessionID: this.state.QRSessionID, country: this.props.pricing.countryCode })
                            .then((res) => {
                                console.log(res);
                                this.onLogin(this.state.QRSessionID);
                            })
                            .catch((err) => {
                                this.setState({ loading: false });
                            });
                    })
                    .catch((err) => {
                        console.log("register err: ", err);
                        this.setState({ loading: false, errorMessage: err, });
                    });
            } else {
                this.setState({ loading: false, });
                this.setState({ errorMessage: "This password doesn't meet the minimum requirements", });
            }
        }
    };

    validate = () => {

        if (!this.state.validLength || !this.state.hasNumber || !this.state.upperCase || !this.state.lowerCase) {
            return false;
        }

        return true;
    }

    onGoogleLogin = (responce) => {
        this.setState({ loading: true, errorMessage: "" });
        console.log("Do Google Login")
        console.log(responce)

        // ✅ Retrieve QRSessionID if it was stored before redirect
        const storedQRSessionID = sessionStorage.getItem('googleLoginQRSessionID');
        const QRSessionID = this.state.QRSessionID || storedQRSessionID;

        // Clear stored QRSessionID
        if (storedQRSessionID) {
            sessionStorage.removeItem('googleLoginQRSessionID');
        }

        // Build request object with only the properties that have values
        const req = {
            provider: "Google",
            QRSessionID: QRSessionID,
            country: this.props.pricing.countryCode
        };

        // Add either code or idToken, but not both
        if (responce.code) {
            req.code = responce.code;
        } else if (responce.access_token) {
            req.idToken = responce.access_token;
        }

        console.log("Google login request:", JSON.stringify(req));
        this.props.login(req)
            .then((res) => {
                console.log(res);
                this.onLogin(QRSessionID);
            })
            .catch((err) => {
                this.setState({ loading: false, errorMessage: err });
            });
    }

    onAppleLogin = (authCode) => {
        this.setState({ loading: true, errorMessage: "" });
        console.log("Apple auth code: " + authCode);

        // Retrieve QRSessionID if it was stored before redirect
        const storedQRSessionID = sessionStorage.getItem('appleLoginQRSessionID');
        const QRSessionID = this.state.QRSessionID || storedQRSessionID;

        // Clear stored QRSessionID
        if (storedQRSessionID) {
            sessionStorage.removeItem('appleLoginQRSessionID');
        }

        const req = {
            provider: "Apple",
            code: authCode,
            QRSessionID: QRSessionID,
            country: this.props.pricing.countryCode
        }
        console.log("Apple login request: ", JSON.stringify(req));
        this.props.login(req)
            .then((res) => {
                console.log(res);
                this.onLogin(QRSessionID);
            }).catch((err) => {
                this.setState({ loading: false, errorMessage: err });
            });
    };

    proceedWithAppleLogin = () => {
        this.setState({ showAppleWarning: false });

        // Store QRSessionID before redirect
        if (this.state.QRSessionID) sessionStorage.setItem('appleLoginQRSessionID', this.state.QRSessionID);

        if (this.props.redirectAppleLogin) {
            // Android/iOS WebView: Redirect to backend endpoint
            const params = new URLSearchParams({
                client_id: process.env.REACT_APP_APPLE_CLIENT_ID,
                redirect_uri: process.env.REACT_APP_API_URL + 'api/authenticate/apple-login-callback',
                response_type: 'code',
                scope: 'name email',
                response_mode: 'form_post'
            });

            if (this.state.QRSessionID) params.append('state', this.state.QRSessionID);

            const authUrl = `https://appleid.apple.com/auth/authorize?${params.toString()}`;
            console.log("🍎 App: Redirecting to Apple with form_post");
            window.location.href = authUrl;
        } else {
            // Web browsers: Use Apple JS SDK with popup
            if (window.AppleID) {
                console.log("🍎 Browser: Using popup mode");
                window.AppleID.auth.signIn()
                    .then((response) => {
                        this.onAppleLogin(response.authorization.code);
                    })
                    .catch(err => {
                        console.error("Apple login error", err);
                    });
            } else {
                console.error("❌ Apple JS SDK not loaded");
                alert("Apple Sign-In is not available");
            }
        }
    };

    onFacebookLogin = (response) => {
        this.setState({ loading: true, errorMessage: "" });
        const req = {
            provider: "Facebook",
            idToken: response.accessToken,
            QRSessionID: this.state.QRSessionID,
            country: this.props.pricing.countryCode
        };
        this.props.login(req)
            .then((res) => {
                console.log(res);
                this.onLogin(this.state.QRSessionID);
            })
            .catch((err) => {
                this.setState({ loading: false });
            });
    }

    render() {
        const limitAccessFireTv = this.props.room?.roomState?.platform === APP_TYPES.FIRE_TV || this.props.devices.limitAccessFireTv;

        return (
            <>
                <div id="" className={styles.columns}>
                    {
                        (window.innerWidth > 780 && !this.state.QRSessionID && !this.props.noQR && !limitAccessFireTv && this.props.variant !== "checkout") &&
                        <>
                            <div id="leftColumn" className={`${styles.column} ${styles.qrWrapper}`}>
                                <QRLogin onLogin={this.onQRLogin} color="black" textStyle={{ color: "black" }}></QRLogin>
                            </div>
                            <div className={`${styles.verticalDivider} `} style={{ marginRight: '40px' }} />
                        </>
                    }
                    <div id="rightColumn" className={styles.column}>
                        {this.state.view === "loginOrSignUp" &&
                            <Form onSubmit={this.checkAccountExists} className={styles.fadeIn}>
                                {this.props.variant === "checkout" && (
                                    <div className={styles.checkoutBanner}>
                                        <div className={styles.checkoutBannerIcon}>
                                            <span>&#10003;</span>
                                        </div>
                                        <div className={styles.checkoutBannerContent}>
                                            <strong>Your codes are ready!</strong>
                                            <p>Login or create an account to activate your games instantly.</p>
                                        </div>
                                    </div>
                                )}
                                <h3 className={styles.formTitle}>Login{!limitAccessFireTv && " or Sign up"}</h3>
                                {!this.props.hideGoogleLogin &&
                                    <div className="mb-2">
                                        <GoogleLoginButton
                                            onSuccess={(res) => this.onGoogleLogin(res)}
                                            onError={() => console.log("Login Failed")}
                                            disabled={this.state.loading}
                                            redirectGoogleLogin={this.props.redirectGoogleLogin}
                                            QRSessionID={this.state.QRSessionID}
                                        />
                                    </div>
                                }
                                {!this.props.hideAppleLogin &&
                                    <div className="mb-2">
                                        <AppleLoginButton
                                            onSuccess={(authCode) => this.onAppleLogin(authCode)}
                                            disabled={this.state.loading}
                                            redirectAppleLogin={this.props.redirectAppleLogin}
                                            QRSessionID={this.state.QRSessionID}
                                            variant={this.props.variant}
                                            onShowWarning={() => this.setState({ showAppleWarning: true })}
                                        />
                                    </div>
                                }
                                <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                                    <hr style={{ flex: 1, border: 'none', opacity: 1, borderTop: '3px solid lightgray' }} />
                                    <span style={{ padding: '0 10px', whiteSpace: 'nowrap' }}>Continue with email</span>
                                    <hr style={{ flex: 1, border: 'none', opacity: 1, borderTop: '3px solid lightgray' }} />
                                </div>

                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Control type="email" placeholder="Enter email" required onChange={this.onChangeEmail} />
                                </Form.Group>

                                {
                                    this.state.errorMessage.length > 0 &&
                                    <Alert variant={"danger"}>
                                        {this.state.errorMessage}
                                    </Alert>
                                }

                                <div className={`${styles.buttonsWrapper} mt-3`}>
                                    <button className={styles.button} type="submit" disabled={!this.state.email}>{this.state.loading ? <DotLoader size="medium" variant="light" /> : limitAccessFireTv ? "Login" : "Login / register"}</button>
                                </div>

                                <Link to={"/forgot-password"} className={`${styles.passwordForget}`}>
                                    <p>Forgot your password?</p>
                                </Link>
                            </Form>
                        }
                        {this.state.view === "login" &&

                            <Form onSubmit={this.handleLoginViaEmail} className={styles.fadeIn} >
                                <button type="button" className={styles.backButton} onClick={() => this.setState({ view: "loginOrSignUp" })} aria-label="Back">
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </button>
                                {this.props.variant === "checkout" && (
                                    <div className={styles.checkoutBanner}>
                                        <div className={styles.checkoutBannerIcon}>
                                            <span>&#10003;</span>
                                        </div>
                                        <div className={styles.checkoutBannerContent}>
                                            <strong>Your codes are ready!</strong>
                                            <p>Login to activate your games instantly.</p>
                                        </div>
                                    </div>
                                )}
                                <h3 className={styles.formTitle}>Login</h3>

                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Control value={this.state.email} type="email" placeholder="Enter email" required onChange={this.onChangeEmail} disabled />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Control autoFocus type="password" placeholder="Password" required onChange={this.onChangePassword} />
                                </Form.Group>
                                {
                                    this.state.errorMessage.length > 0 &&
                                    <Alert variant={"danger"}>
                                        {this.state.errorMessage}
                                    </Alert>
                                }

                                <div className={`${styles.buttonsWrapper} mt-3`}>
                                    <button className={styles.button} type="submit" disabled={!this.state.email || this.state.loading}>{this.state.loading ? <DotLoader size="medium" variant="light" /> : "Login"}</button>
                                </div>

                                <Link to={"/forgot-password"} className={`${styles.passwordForget}`}>
                                    <p>Forgot your password?</p>
                                </Link>
                            </Form>
                        }
                        {this.state.view === "register" &&
                            <Form onSubmit={this.handleRegisterViaEmail} className={styles.fadeIn}>
                                <button type="button" className={styles.backButton} onClick={() => this.setState({ view: "loginOrSignUp" })} aria-label="Back">
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </button>
                                {this.props.variant === "checkout" && (
                                    <div className={styles.checkoutBanner}>
                                        <div className={styles.checkoutBannerIcon}>
                                            <span>&#10003;</span>
                                        </div>
                                        <div className={styles.checkoutBannerContent}>
                                            <strong>Your codes are ready!</strong>
                                            <p>Create an account to activate your games instantly.</p>
                                        </div>
                                    </div>
                                )}
                                <h3 className={styles.formTitle}>Register </h3>
                                {
                                    !limitAccessFireTv ?
                                        <>
                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                <Form.Control type="email" value={this.state.email} placeholder="Enter email" required onChange={this.onChangeEmail} />
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                                <Form.Control autoFocus autoComplete="none" className="mb-2" type="password" placeholder="Password" required onChange={this.onChangePassword} isInvalid={this.state.password.length > 0 && (!this.validate())}></Form.Control>
                                                <ul className={styles.passwordRequirements}>
                                                    <li className={this.state.password.length > 0 && (this.state.validLength ? "text-success" : "text-danger")}>
                                                        Your password must be at least 8 characters
                                                    </li>
                                                    <li className={this.state.password.length > 0 && (this.state.hasNumber ? "text-success" : "text-danger")}>
                                                        Your password must include a number
                                                    </li>
                                                    <li className={this.state.password.length > 0 && (this.state.upperCase ? "text-success" : "text-danger")}>
                                                        Your password must include an upper case letter
                                                    </li>
                                                    <li className={this.state.password.length > 0 && (this.state.lowerCase ? "text-success" : "text-danger")}>
                                                        Your password must include a lower case letter
                                                    </li>
                                                </ul>
                                            </Form.Group>
                                            {
                                                this.state.errorMessage.length > 0 &&
                                                <Alert variant={"danger"}>
                                                    {this.state.errorMessage}
                                                </Alert>
                                            }

                                            <div className={`${styles.buttonsWrapper} mt-3`}>
                                                <button className={styles.button} type="submit" disabled={!this.validate()}>
                                                    {this.state.loading ? <DotLoader size="medium" variant="light" /> : "Register"}
                                                </button>
                                            </div>

                                            <Link to={"/forgot-password"} className={`${styles.passwordForget}`}>
                                                <p>Forgot your password?</p>
                                            </Link>
                                        </>
                                        :
                                        <>
                                            <div className={styles.termsContainer} >
                                                You cannot register from the FireTV app. Please Visit Game.City to find out more.
                                            </div>
                                        </>
                                }

                            </Form>
                        }
                    </div>
                </div>
                <br />
                {
                    (!limitAccessFireTv || this.state.view !== "register") &&
                    <div className={styles.termsContainer}>
                        By logging in {!limitAccessFireTv && "or registering"} you are agreeing to the {limitAccessFireTv ? "Game.City Terms" : <Link to="/terms">Game.City Terms</Link>}
                    </div>
                }

                {/* Apple Sign-In Warning Modal */}
                {this.state.showAppleWarning && (
                    <div className={styles.appleWarningOverlay} onClick={() => this.setState({ showAppleWarning: false })}>
                        <div className={styles.appleWarningModal} onClick={(e) => e.stopPropagation()}>
                            <div className={styles.appleWarningIcon}>
                                <FontAwesomeIcon icon={faApple} />
                            </div>
                            <h2>Continue with Apple</h2>
                            <p className={styles.appleWarningSubtitle}>Please note the following before proceeding</p>

                            <div className={styles.appleWarningBox}>
                                <div className={styles.appleWarningBoxIcon}>
                                    <span>⚠</span>
                                </div>
                                <div className={styles.appleWarningBoxContent}>
                                    <p><strong>Your games will be redeemed against the email associated to your Apple ID.</strong></p>
                                    <p className={styles.warningHighlight}>If you hide your email, games will be linked to your hidden Apple address.</p>
                                </div>
                            </div>

                            <div className={styles.appleWarningButtons}>
                                <button className={styles.appleWarningCancel} onClick={() => this.setState({ showAppleWarning: false })}>
                                    Cancel
                                </button>
                                <button className={styles.appleWarningContinue} onClick={() => this.proceedWithAppleLogin()}>
                                    Continue
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

const GoogleLoginButton = ({ onSuccess, onError, disabled, redirectGoogleLogin, QRSessionID }) => {
    const handleGoogleLogin = () => {
        // Check if we need to use redirect flow (iOS app)
        if (redirectGoogleLogin) {
            // Store QRSessionID before redirect
            if (QRSessionID) sessionStorage.setItem('googleLoginQRSessionID', QRSessionID);

            const params = new URLSearchParams({
                client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
                redirect_uri: process.env.REACT_APP_API_URL + 'api/authenticate/google-login-callback',
                response_type: 'code',
                scope: 'openid email profile',
            });

            if (QRSessionID) params.append('state', QRSessionID);

            const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
            console.log("🔵 iOS: Redirecting to Google OAuth");
            console.log("🔍 Full Auth URL:", authUrl);
            window.location.href = authUrl;
        }
        // Check if we're in the Android app
        else if (window.AndroidBridge && typeof window.AndroidBridge.launchGoogleSignIn === 'function') {
            console.log("🟢 Launching native Google Sign-In via Android Bridge");
            window.AndroidBridge.launchGoogleSignIn();
        } else {
            // Fall back to web-based Google login
            console.log("🌐 Using web-based Google Sign-In");
            login();
        }
    };

    const login = useGoogleLogin({
        onSuccess: (response) => onSuccess(response),
        onError: (error) => onError(error),
        scope: "openid email profile",
    });

    return (
        <button
            type="button"
            className="btn btn-outline-primary w-100 mb-2"
            onClick={handleGoogleLogin}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
            disabled={disabled}
        >
            <FontAwesomeIcon icon={faGoogle} style={{ marginRight: 8 }} />
            Sign in with Google
        </button>
    );
};

const AppleLoginButton = ({ onSuccess, disabled, redirectAppleLogin, QRSessionID, variant, onShowWarning }) => {
    const handleAppleLogin = () => {
        // For checkout variant, show warning modal first
        if (variant === "checkout" && onShowWarning) {
            onShowWarning();
            return;
        }

        // Store QRSessionID before redirect
        if (QRSessionID) sessionStorage.setItem('appleLoginQRSessionID', QRSessionID);

        if (redirectAppleLogin) {
            // Android/iOS WebView: Redirect to backend endpoint
            const params = new URLSearchParams({
                client_id: process.env.REACT_APP_APPLE_CLIENT_ID,
                redirect_uri: process.env.REACT_APP_API_URL + 'api/authenticate/apple-login-callback',
                response_type: 'code',
                scope: 'name email',
                response_mode: 'form_post'
            });

            if (QRSessionID) params.append('state', QRSessionID);

            const authUrl = `https://appleid.apple.com/auth/authorize?${params.toString()}`;
            console.log("🍎 App: Redirecting to Apple with form_post");
            console.log("🔍 Full Auth URL:", authUrl);
            window.location.href = authUrl;
        } else {
            // Web browsers: Use Apple JS SDK with popup
            if (window.AppleID) {
                console.log("🍎 Browser: Using popup mode");
                window.AppleID.auth.signIn()
                    .then((response) => {
                        onSuccess(response.authorization.code);
                    })
                    .catch(err => {
                        console.error("Apple login error", err);
                    });
            } else {
                console.error("❌ Apple JS SDK not loaded");
                alert("Apple Sign-In is not available");
            }
        }
    };

    return (
        <button
            type="button"
            className="btn btn-outline-dark w-100 mb-2"
            onClick={handleAppleLogin}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
            disabled={disabled}
        >
            <FontAwesomeIcon icon={faApple} style={{ marginRight: 8 }} />
            Sign in with Apple
        </button>
    );
};

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing,
        devices: state.devices,
    };
}


const mapDispatchToProps = (dispatch) => {
    return {
        login: (req) => {
            return dispatch(login(req))
        },
        autoLoginQRSession: (QRSessionID, UserID) => {
            return dispatch(autoLoginQRSession(QRSessionID, UserID))
        },
        register: (email, password, country) => {
            return dispatch(register(email, password, country))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));